module.exports = __webpack_public_path__ + "img/winner-weekly.c0fa318b.png";